import React from 'react';
import Image from 'next/image';

export const ReasonItem = ({
  id,
  image,
  title,
  text,
  subtext = '',
  highlight = '',
  highlightAdditional = [],
}) => {
  return (
    <div className="reason-list__item reason-item">
      <div className="reason-item__image">
        <Image
          src={image}
          alt={id}
          className="reason-item__image--rounded"
          layout="fill"
        />
        {/* layout="fill"  placeholder='blur' */}
      </div>
      {/* <img /> */}
      <div className="reason-item__content">
        <h3 className="reason-item__title main-title">{title}</h3>
        <p className="reason-item__text title">{text}</p>
        {subtext && <p className="reason-item__text title">{subtext}</p>}
        {highlight && (
          <div className="reason-item__text title-bold highlight">
            {highlight}
            {/* {!!highlightAdditional.length && (
              <ul>
                {highlightAdditional.map((i, idx) => (
                  <li key={idx} className="title">
                    {i}
                  </li>
                ))}
              </ul>
            )} */}
          </div>
        )}
      </div>
    </div>
  );
};
